if (!customElements.get('buy-product-modal')) {
  customElements.define(
    'buy-product-modal',
    class BuyProductModal extends HTMLElement {
      constructor() {
        super();
        //Enum para o tipo de navegação entre os passos
        this.Steps = Object.freeze({
          PREV: 'PREV',
          NEXT: 'NEXT',
          FINAL: 'FINAL',
          CLOSE: 'CLOSE',
          getKey: function (value) {
            return Object.keys(this).find((key) => this[key] === value);
          },
        });
      }

      //Inicializa as prorpeidades
      //Algumas, principalmente as que precisam de DOM, não carregam no construtor
      initProperties() {
        this.steps = this.querySelectorAll('.step');
        this.step = 1;
        this.closeButton = this.querySelector('#buy-modal__close');
        this.prevButton = this.querySelector('#buy-modal__prev');
        this.formId = this.dataset.sectionId;
        this.cartOptions = [];
        this.utils = new Utils();
        this.productService = new ProductService();
        this.cartService = new CartService();
        this.buyButton = this.steps[this.steps.length - 1].querySelector('button');
        this.stepBar = this.querySelector('.stepBar');
        this.variantInput = this.closest('.product').querySelector('.product-info-wrap-content product-form .form [name="product-id"]');
        this.loadingSpinner = this.querySelector('.loading-spinner');
        this.contentContainer = this.querySelector('.buy-product-modal__options-container');
      }

      connectedCallback() {
        this.initProperties();
        this.init();
        this.buyButtonListener();
      }

      //Configura o fluxo
      init() {
        if (!this.modalData?.options) {
          this.modalData = this.getModalData();
        }

        this.handleWorker();

        this.closeButton.addEventListener('click', () => {
          this.closeModal();
        });

        this.prevButton.addEventListener('click', () => {
          this.prevStep();
        });

        this.steps.forEach(step => {
          const buttons = step.querySelectorAll('button.input-radio');

          if (buttons.length > 0) {
            buttons.forEach(button => {
              this.buttonListener(button, step);
            });
          }
        });
        this.loadStepBar();
      };

      //Carrega a barra de progresso - visual
      loadStepBar() {
        if (!this.stepBar) return;

        const length = this.steps.length;
        const currentStep = this.step;

        //Como a barra começa em left -0.5%, devido ao border-radius, ela deve terminar em 101% para contemplar toda a largura.
        const widthPercentage = (currentStep / length ) * 100 + 1;

        const clampedWidth = Math.min(101, Math.max(0, widthPercentage));
        
        this.stepBar.style.width = `${clampedWidth.toFixed(2)}%`
      }

      //Lógica de worker para paralelismo
      //É inicializado assim que a página carrega e carrega as informações dos produtos/options direto da Shopify em segundo plano
      //sem travar a UI
      async handleWorker() {
        this.showLoading();

        //Necessário um BLOB para evitar impedimento da inicialização de arquivos locais por navegadores Chromium (Chrome e Edge) 
        const createWorker = async (workerUrl) => {
          try {
            const response = await fetch(workerUrl);
            const workerCode = await response.text();
            const blob = new Blob([workerCode], { type: 'application/javascript' });
            const blobUrl = URL.createObjectURL(blob);
            return new Worker(blobUrl);
          } catch (error) {
            console.error('Erro ao criar worker:', error);
            return null;
          }
        }

        // const worker = new Worker(`${this.dataset.worker}`, { type: 'module'});
        const worker = await createWorker(this.dataset.worker);

        if(!worker) return;

        worker.postMessage({
          id: 'get-all-products',
          options: this.modalData.options,
          baseUrl: window.location.origin + '/' // URL completa da loja
        });

        
        worker.onmessage = e => {
          if (e.data.id == 'get-all-products') {
            if (e.data?.options.length > 0) {
              const options = e.data.options;

              if (this.modalData?.options) {
                this.modalData.options = options;
              } else {
                this.modalData = this.getModalData();
                this.modalData.options = options;
              }

              worker.terminate();

              this.querySelectorAll('.field__content .price-item').forEach(element => {
                if (!element.dataset?.id) return;
                
                const price = this.modalData.options.find(dataOption => dataOption.id === Number(element.dataset.id)).price;
                if (!price) return;

                element.textContent = this.utils.numberToMoney(price, "R$")
              });

              this.cartOptions.forEach(cartOption => {
                const price = this.modalData.options.find(dataOption => dataOption.id === Number(cartOption.id)).price;

                if (!price) return;

                cartOption.price = price;
              });
              
              this.hideLoading();
            }          
          }
        }
      }

      hideLoading() {
        if (!this.loadingSpinner) return;

        this.loadingSpinner.classList.add('hidden');
        this.loadingSpinner.querySelector('div').classList.add('hidden');
        this.contentContainer.classList.remove('hidden');
      }

      showLoading() {
        if (!this.loadingSpinner) return;

        this.loadingSpinner.classList.remove('hidden');
        this.loadingSpinner.querySelector('div').classList.remove('hidden');
        this.contentContainer.classList.add('hidden');
      }

      closeModal() {
        this.loadStep(this.steps[0], [], this.steps[this.step - 1], this.Steps.CLOSE);
      }

      //Retorna qual o próximo passo que deverá ser carregado
      nextStep(step, nextOptions) {
        if (nextOptions && nextOptions[0] != 0) {
          const nextStep = step + 1;
          const nextStepElement = this.querySelector(
            `.step[data-step="${nextStep}"]`
          );
          nextStepElement ? (this.step = nextStep) : "";
          return nextStepElement;
        }
        return null;
      }

      //Calcula passo anterior a ser carregado
      prevStep() {
        if (this.step == 1) return;

        const step = this.steps[this.step - 1];
        const prev = step.dataset.previousStep;
        const prevStep = this.steps[prev - 1];

        this.loadStep(prevStep, [], this.steps[this.step - 1], this.Steps.PREV);
      }

      //Lógica das seleções/inputs radiais
      //Chama o próximo passo
      buttonListener(button, step) {
        const currentStep = Number(step.dataset.step);
        const container = button.closest('.field__content');

        container.addEventListener('click', async (e) => {
          e.preventDefault();

          const nextOptions = button.dataset.nextOptions != '' 
            ? button.dataset.nextOptions.split(',').map(Number)
            : '';
          
          if (nextOptions != '') {
           const nextStep = this.nextStep(currentStep, nextOptions);

           if (nextStep) {
            this.loadStep(nextStep, nextOptions, step, this.Steps.NEXT);
           } 
          } else {
            this.loadStep(this.steps[this.steps.length - 1],
              '',
              step,
              this.Steps.FINAL
            );
          }

          const labelContainer = button.closest('.field__content').querySelector('.label__container');

          const isChecked = button.classList.contains('checked');
          const hasCheckedClass = labelContainer.classList.contains('checked');

          if (!isChecked && !hasCheckedClass) {
            //Retirar checks
            button
              .closest('fieldset')
              .querySelectorAll('.field__container .input-radio')
              .forEach(buttonFound => {
                buttonFound.classList.remove('checked');
                buttonFound.closest('.field__content').querySelector('.label__container').classList.remove('checked');
              });

            //Adicionar check ao botão e label
            button.classList.add('checked');
            labelContainer.classList.add('checked'); //label
            
            if (button.dataset?.id) await this.loadFinalStepData(button.dataset.id);

            if (this.step == this.steps.length) this.loadFinalStep(this.steps[this.step - 1]);
          }
        });
      }

      //Carrega as configurações JSON do modal
      getModalData() {
        try {
          const scriptTag = this.querySelector('#modal-data');

          if (!scriptTag) {
            console.error("Elemento script não encontrado");
            return null;
          }

          const jsonString = scriptTag.textContent.trim();

          if (!jsonString) {
            console.error("O conteúdo do script está vazio");
            return null;            
          }
          
          if (!jsonString.startsWith("{") || !jsonString.endsWith("}")) {
            throw new Error("Formato JSON inválido");
          }

          return JSON.parse(jsonString);
        } catch(e) {
          console.error("Erro ao parsear JSON:", e);
          console.error("Conteúdo problemático:", scriptTag.textContent);
          return null;          
        }
      }

      //Carrega o passo atual, com as opções adicionais
      //Caso não tenha opções adicionais, carrega o passo final
      //Possível também carregar o passo anterior ou fechar o modal
      async loadStep(stepEl, nextOptions, currentStep, stepToLoad) {
        if (stepToLoad == this.Steps.NEXT) {
          if (stepEl.dataset.step > 1) this.prevButton.classList.remove('hidden');

          currentStep.dataset.nextStep = stepEl.dataset.step;
          stepEl.dataset.previousStep = currentStep.dataset.step;

          //Caso o próximo passo não tenha conteúdo, criar e adicionar - usando as informações estáticas das opções.
          const optionsToLoad = [];

          for (const nextOption of nextOptions) {
            const option = this.getOptionData(nextOption);

            if (option) {
              optionsToLoad.push(option);
            }
          }
          
          const step = stepEl.dataset.step;
          const fieldset = stepEl.querySelector('fieldset');

          for (const option of optionsToLoad) {
            if (!option) continue; // Skip null/undefined options           
                        
            const newFieldContainer = `
                <div class="field__container">
                    <div class="field__content">
                        <div class="input__container">
                          <div class="price__container">
                            <div class="price__regular">
                              <span class="price-item price-item--regular" data-id="${option.id}">
                                ${option?.price > 0
                                  ? this.utils.numberToMoney(option.price, "R$")
                                  : ''
                                }
                              </span>
                            </div>
                          </div>
                          <button 
                              type="button" 
                              class="input-radio"
                              name="buy-step-${step}" 
                              id="step-${step}-${option.id}"
                              data-id="${option.id}"
                              data-next-options="${option.nextOptions}"
                              value="${option.id}"
                          ></button>
                        </div>
                        <label class="label__container" for="step-${step}-${option.id}">
                            <div class="label__name">
                                <span><strong>${option.name}</strong></span>
                            </div>
                            ${option.description ? `<p>${option.description}</p>` : ''}
                        </label>
                    </div>
                </div>
            `;
            
            fieldset.insertAdjacentHTML("beforeend", newFieldContainer);
        }

          const buttons = stepEl.querySelectorAll('button.input-radio');
          buttons[0].focus();

          for (const button of buttons) {
            this.buttonListener(button, stepEl);
          };
        }

        if (stepToLoad == this.Steps.PREV) {
          this.cartOptions = this.cartOptions.filter(option => option.step < Number(currentStep.dataset.step));

          currentStep.querySelectorAll('.checked').forEach(element => element.classList.remove('checked'));

          this.removeOptionsFieldset(currentStep);

          if (stepEl.dataset.step == 1) {
            this.prevButton.classList.add('hidden');
          }
        }

        //Fechar Modal
        //Apagando todas as options do cartOptions.
        if (stepToLoad == this.Steps.CLOSE) {
          if (this.cartOptions.length > 0) this.cartOptions.length = 0;

          this.classList.add('hidden');
          document.querySelector('body').classList.remove('no-scroll');
          this.prevButton.classList.add('hidden');

          //Remove as opções carregadas para cada passo que não o primeiro
          for(const [index, step] of this.steps.entries()) {
            if (index == 0) continue;
            this.removeOptionsFieldset(step);
          }

          this.querySelector('.buy-product-modal__error-message-wrapper').style.display = 'none';
          this.step = 1;
        }

        if (stepToLoad == this.Steps.FINAL) {
          stepEl.dataset.previousStep = currentStep.dataset.step;
          this.prevButton.classList.remove('hidden');
        }

        
        this.step = Number(stepEl.dataset.step);
        this.loadStepBar();
        currentStep.classList.add("hidden");
        stepEl.classList.remove("hidden");
        
        const firstFocusable = stepEl.querySelector('.final-step__content, button, input, [tabindex="0"]');
        this.utils.focusElement(firstFocusable, stepEl);
      }

      //Remove dados do fieldset (opções do passo)
      //Exemplo de uso: ao fechar o modal
      removeOptionsFieldset(stepElement) {
        stepElement.querySelectorAll("fieldset").forEach(fieldset => {
            // Seleciona todos os elementos container dentro do fieldset atual
            const loopStep = fieldset.closest('.step').dataset.step;
            if (loopStep > 1 && loopStep < this.steps.length) {
                const containers = fieldset.querySelectorAll('.field__container');
                console.log('\ncontainers', containers)
    
                // Remove cada container
                containers.forEach(container => {
                  console.log('\ncontainer', container)
                  container.remove();
                });
            }
          }
        );        
      }

      //Carrega os dados do passo final
      //Ocorre a cada seleção - cartOptions é atualizado.
      async loadFinalStepData(id) {
        if (!id) return;

        const option = this.getOptionData(id);
        const onCart = this.cartOptions.some(cartOption => {
          return cartOption?.id === id && cartOption?.step === option.step
        });

        if (onCart) return;

        if (this.cartOptions.length > 0 && option.step < this.cartOptions[this.cartOptions.length - 1].step) {
          this.cartOptions = this.cartOptions.filter(cartOption => cartOption.step <= option.step);
        }

        const index = this.cartOptions.findIndex(op => op.step === option.step);
        
        if (index !== -1) {
          this.cartOptions[index] = option;
        } else {
          const optionToPush = option;
          this.cartOptions.push(optionToPush)
        }
      }

      getOptionData(id) {
        const option = this.modalData.options.find(option => option.id == id);
        return option;
      }

      async loadFinalStep(step) {
        this.loadStepBar();
        await this.loadVariant(step);

        const containers = Array.from(step.querySelectorAll('.final-step__content'));

        containers
          .filter(container => parseInt(container.dataset.step) < this.steps.length)
          .forEach(container => container.classList.add('hidden'));

        this.cartOptions.forEach(option => {
          try {
            if (!option.show) return;

            const labelContainer = step.querySelector(`.label__container[data-step="${option.step}"`);
            const priceContainer = labelContainer.closest('.final-step__content').querySelector('span');

            if (!labelContainer) throw new Error(`Container não encontrado para step ${option.step}`);

            this.updateElementContent(labelContainer, 'small', option.name);

            const priceStr = option?.price > 0
              ? this.utils.numberToMoney(option.price, 'R$')
              : '';
            
            this.updateElementContent(priceContainer, 'span', priceStr);

            labelContainer.closest('.final-step__content').classList.remove('hidden');
          } catch (e) {
            console.error("Erro ao atualizar texto:", e.message);
            return false;              
          }
        });
          
        this.subTotal();
        // this.installments();
      }

      //Carrega a variante do produto atual (página) se houver tal demarcação na configuração da opção adicional
      //Se não houver, utilizar a primeira variante (padrão)
      //Se houver, verificar se já há uma variante
      //Se houver, utilizar a que tiver o menor preço entre ambas
      async loadVariant(step) {
        if (!this?.product) {
          this.product = await this.productService.getProduct(this.dataset.productHandle);
        }
      
        const priceContainer = step.querySelector(`.final-step__content-container [data-step='${this.step}'] .price__container .price-item`);
        let discountVariant;

        for (const cartOption of this.cartOptions) {
          if (cartOption?.useProduct) {
            const temp = this.product.variants.find(variant => variant.title.toLowerCase() == cartOption.useProduct.toLowerCase());
            if (temp && temp.price) {
              if (!discountVariant) discountVariant = temp;
              else if (temp.price < discountVariant.price) discountVariant = temp;
            }
          }
        }
        const assignProductPrice = (prod) => {
          this.variantInput.value = Number(prod.id);

          const price = this.utils.numberToMoney(prod.price/100, "R$");
          this.productPrice = prod.price / 100;

          priceContainer.textContent = price;
        }

        if (discountVariant) {
          assignProductPrice(discountVariant);
          return;
        }
        
        assignProductPrice(this.product.variants[0]);
      }

      //Atualiza o conteúdo de um elemento, criando-o se não existir
      //Caso o appendChild seja false, ele insere o elemento no começo do container
      updateElementContent(container, tag, textContent, appendChild = true) {
        let element = container.querySelector(tag);

        if (!element) {
          element = document.createElement(tag);
          if (appendChild) {
            container.appendChild(element);
          } else {
            container.prepend(element);
          }
        }

        element.textContent = textContent;
        return true;
      }

      //Mostrar total da compra - passo final
      subTotal() {
        const subtotalEl = this.steps[this.steps.length - 1].querySelector('.subtotal .price__regular');
        const total = this.cartOptions.reduce((acc, option) => {
          if (option?.price) {
            return acc + option.price
          }
          return acc
        }, 0);
        
        const subtotal = this.productPrice + total;

        this.updateElementContent(subtotalEl, 'span', this.utils.numberToMoney(subtotal, 'R$'));
      }

      //Lógica de adição ao carrinho
      buyButtonListener() {
        this.buyButton.addEventListener('click', async (e) => {
          e.preventDefault();

          this.handleButton(this.buyButton);

          const cart = await this.cartService.getCart();

          // Encontrar o maior groupId existente no carrinho
          let groupId = cart.items
            .filter(item => item?.properties?.groupId) // Filtra apenas itens com groupId
            .reduce((max, current) => {
              const currentId = Number(current.properties.groupId);
              return currentId > max ? currentId : max;
            }, 0); // Começa com 0 como valor inicial
          
          // Incrementar o groupId para os novos itens
          groupId += 1; // Isso garante que novos itens terão um ID único

          //Informações do produto (ID da variante, quantidade, valor, etc)
          const variantId = Number(this.variantInput.value);
          
          // const variantData = this.utils.getJSONData(`ProductJson-${this.sectionId}`).offers.find(obj => obj.identifier == variantId)
          // const maxQuantity = variantData?.inventoryLevel.value || 0

          // const quantityValue = Number(this.closest('product-info').querySelector('quantity-input .quantity__input').value);
          //Agora quantidade é sempre 1 - mas caso volte a ser selecionável:
          // const quantity = quantityValue > maxQuantity ? maxQuantity : quantityValue;
          const quantity = 1;

          //Produto em si (que já seria comprada sem o modal)
          const options = this.cartOptions.map(cartOptions => cartOptions.name)
          const product = {
            id: variantId,
            quantity,
            properties: {
              custom: true,
              groupId,
              options,
            }
          }

          //Produtos/opções/adicionais
          const items = [];
          this.cartOptions.forEach(
              cartOption => {
                  if (cartOption.shopifyId) {
                      const item = {
                          id: Number(cartOption.shopifyId),
                          quantity,
                          properties: {
                            groupId
                          }
                      }
                      items.push(item);
                  }
              }
          );

          items.push(product);
          
          if (items.length > 0)  {
            const result = await this.cartService.addToCart(items);

            if (result?.message) {
              const alert = this.querySelector('.buy-product-modal__error-message-wrapper');
              alert.style.display = 'block';
              alert.querySelector('.buy-product-modal__error-message').textContent = result.message;
            } else {
              window.location.href = '/cart'
            }
          }
        });
      }

      handleButton(button) {
        if (button.classList.contains('loading')) {
          return;
        }

        button.setAttribute('aria-disabled', true);
        button.classList.add('loading');
        this.querySelector('.button-overlay-spinner').classList.remove('hidden');
      }
    }
  );
}
